export const new_node = {
  __new__: "new_node",
} as const

export type NewNode = typeof new_node
